import React from "react";
import AdminLayout from "./AdminLayout";
import SessionManagement from "../../components/Admin/SessionManagement";

const SessionsPage = () => {
  return (
    <AdminLayout>
      <SessionManagement />
    </AdminLayout>
  );
};

export default SessionsPage;
